import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import CrehanaForBusiness from "@crehana/icons/logos/CrehanaForBusiness";
import { useOrganizationBranding } from "@crehana/layouts/organization-branding-provider";
import clsx from "clsx";
const OrganizationLogoImage = ({ alt, className })=>{
    const [is404Image, setIs404Image] = useState(false);
    const { branding } = useOrganizationBranding();
    const handleImageError = ()=>setIs404Image(true);
    if (is404Image) return /*#__PURE__*/ jsx(CrehanaForBusiness, {
        size: 32,
        "aria-hidden": true,
        className: className
    });
    return /*#__PURE__*/ jsx("img", {
        src: branding.imageLogo.absoluteUrl,
        alt: alt,
        "aria-hidden": true,
        width: 128,
        className: clsx('tw-max-h-4 tw-w-auto tw-max-w-[12.8rem]', className),
        onError: handleImageError
    });
};
const components_OrganizationLogoImage = OrganizationLogoImage;
export default components_OrganizationLogoImage;
